import { types } from "../../types/types";
import { handleErrorApi } from "../../helpers/randoms";
import { finishSpinner, startSpinner } from "../ui/spinner";
import LaboratorioService from "../../services/LaboratorioService";
import { changeStepper } from '../preAfiliado/stepper';
import { AUTORIZACIONES_SOLICITUDES_ESTADOS, TAMANO_IMAGENES } from '../../utils/constants';
import { startAlerta } from '../ui/alertas';
import { fileSize } from '../../helpers/filesFunctions';
import { setActiveStep, setShowForm } from '../autorizaciones/Autorizaciones';

const baseUrl = process.env.REACT_APP_API_URL;

export const laboratorioClear = () => {
  return {
    type: types.laboratorioClear,
  };
};

export const resetBuscadorPracticasLaboratorio = () => {
  return {
    type: types.coseguroResetBuscadorPracticas,
  };
};

export const resetPracticasLaboratorio = () => {
  return {
    type: types.laboratorioCleanPracticas,
  };
};

export const resetPracticasSeleccionadasLaboratorio = () => {
  return {
    type: types.laboratorioCleanPracticasSeleccionadas,
  };
};

export const laboratorioCleanDocumentacion = () => {
  return {
    type: types.laboratorioCleanDocumentacion,
  };
};

export const laboratorioSetDocumentacion = (payload) => {
  return {
    type: types.laboratorioSetDocumentacion,
    payload
  };
};

export const laboratorioDeleteDocumentacion = (payload) => {
  return {
    type: types.laboratorioDeleteDocumentacion,
    payload
  };
};

export const getSolicitudesLaboratorio = (idAfiliado, idCentroMedico, 
  idEfectorFacturacion) => async (dispatch) => {
  try {
    dispatch(startSpinner());
    const response = await LaboratorioService.getSolicitudesLaboratorio( 
      idAfiliado, idCentroMedico, idEfectorFacturacion
    );
    const body = await response.json();
    if (response.ok) {
      dispatch({
        type: types.laboratorioSetSolicitudesAutorizadas,
        payload: body,
      });
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      "Error al buscar las Solicitudes Autorizadas",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

// export const getPracticaLaboratorioTexto = (texto) => async (dispatch) => {
//   try {    
//     const response = await LaboratorioService.getBuscardorPracticasLaboratorioTexto(texto);
//     const body = await response.json();
//     if (response.ok) {
//       dispatch({
//         type: types.laboratorioGetBuscadorPracticasSuccess,
//         payload: body,
//       });
//     } else {
//       throw body;
//     }
//   } catch (error) {
//     dispatch({ type: types.laboratorioGetBuscadorPracticasError });
//     handleErrorApi(
//       dispatch,
//       error,
//       "Error al traer los códigos de practicas de laboratorio",
//       "Ha ocurrido un error. Intente nuevamente"
//     );
//   }
// };

export const getPracticasLaboratorio = (data) => async (dispatch) => {
  try {
    dispatch(startSpinner());
    const response = await LaboratorioService.getPracticasLaboratorio(data);
    const body = await response.json();
    if (response.ok) {
      dispatch({
        type: types.laboratorioGetPracticasSuccess,
        payload: body,
      });
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    dispatch({ type: types.laboratorioGetPracticasError });
    handleErrorApi(
      dispatch,
      error,
      "Error al traer las practicas de laboratorio",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const addPracticaLaboratorioInSession = (data) => async (dispatch, getState) => {
  dispatch(startSpinner());
  const { practicas } = getState().laboratorio;
  const practica = data;
  const newPracticas = [...practicas, practica];
  dispatch({
    type: types.laboratorioAddPractica,
    payload: newPracticas,
  });
  dispatch(finishSpinner());    
};

export const addPracticaLaboratorio = (data) => async (dispatch, getState) => {
  try {
    dispatch(startSpinner());
    const response = await LaboratorioService.addPracticaLaboratorio(data);
    const body = await response.json();
    if (response.ok) {
      const { practicas } = getState().laboratorio;
      const practica = body;
      const newPracticas = [...practicas, practica];
      dispatch({
        type: types.laboratorioAddPractica,
        payload: newPracticas,
      });
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      "Error al agregar la practica de laboratorio",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const deletePracticaLaboratorio = (data) => async (dispatch, getState) => {
  try {
    dispatch(startSpinner());
    const response = await LaboratorioService.deletePracticaLaboratorio(data);
    const body = await response.json();
    if (response.ok) {
      const { practicas } = getState().laboratorio;
      const newPracticas = practicas.filter(s => s.idCodNom !== data.idCodNom);
      dispatch({
        type: types.laboratorioAddPractica,
        payload: newPracticas,
      });
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      "Error al eliminar la practica de laboratorio",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const setPracticasSeleccionadasLaboratorio = (idAfiliado, practicas, 
  idCentroMedico, idEfectorFacturacion, ingresoCab = false) => async (dispatch, getState) => {
  try {
    dispatch(startSpinner());
    const { step } = getState().stepper;
    const { activeStep } = getState().autorizaciones;
    const response = await LaboratorioService.checkPracticasAutorizacion( 
      idAfiliado, JSON.stringify(practicas), idCentroMedico, idEfectorFacturacion
    );
    const body = await response.json();
    if (response.ok) {
      dispatch({
        type: types.laboratorioSetPracticasSeleccionadas,
        payload: body,
      });
      if(!ingresoCab)
        dispatch(changeStepper(step + 1));
      else{
        dispatch( setShowForm(false) );
        dispatch( setActiveStep(activeStep + 1) );
      }
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      "Error al seleccionar las practicas de laboratorio",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const setGruposSeleccionadosLaboratorio = (grupos, ingresoCab) => async (dispatch, getState) => {
  try {
    dispatch(startSpinner());
    const { step } = getState().stepper;
    dispatch({
      type: types.laboratorioSetGruposSeleccionados,
      payload: grupos,
    });
    if(!ingresoCab)
      dispatch(changeStepper(step + 1));
    dispatch(finishSpinner());    
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      "Error al seleccionar las grupos de laboratorio",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const confirmSolicitudLaboratorio = (data, addedPracticasAndAbonar, closeModal) => async (dispatch) => {
  try {
    dispatch(startSpinner());
    const response = await LaboratorioService.confirmSolicitudLaboratorio( data );
    const body = await response.json();
    if (response.ok) {
      dispatch({
        type: types.laboratorioSetSolicitudes,
        payload: body.solicitudes,
      });

      if(body.turno) {
        addedPracticasAndAbonar(body.turno);
      }
      else{
        closeModal();
        const autorizada = body.solicitudes
          .find(s => s.idEstadoSolicitud === AUTORIZACIONES_SOLICITUDES_ESTADOS.TERMINADA);
        const pendiente = body.solicitudes
          .find(s => s.idEstadoSolicitud === AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE);                  
        dispatch(
          startAlerta(
            `${autorizada 
                ? 'Autorizada N° ' + autorizada.idSolicitud : ''} ${pendiente 
                  ? ' / Pendiente N° ' + pendiente.idSolicitud : ''}`
              ,'success'
              ,'Solicitud/es generada/s correctamente:'
          )
        );
      }
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      "Error al generar la solicitud de laboratorio",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const confirmSolicitudLaboratorioCab = (data, setRedirect) => async (dispatch) => {
  try {
    dispatch(startSpinner());
    const response = await LaboratorioService.confirmSolicitudLaboratorioCab( data );
    const body = await response.json();
    if (response.ok) {
      dispatch({
        type: types.laboratorioSetSolicitudes,
        payload: body.solicitudes,
      });

      const autorizada = body.solicitudes
        .find(s => s.idEstadoSolicitud === AUTORIZACIONES_SOLICITUDES_ESTADOS.TERMINADA);
      const pendiente = body.solicitudes
        .find(s => s.idEstadoSolicitud === AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE);                  
      dispatch(
        startAlerta(
          `${autorizada 
              ? 'Autorizada N° ' + autorizada.idSolicitud : ''} ${pendiente 
                ? ' / Pendiente N° ' + pendiente.idSolicitud : ''}`
            ,'success'
            ,'Solicitud/es generada/s correctamente:'
        )
      );
      setRedirect && setRedirect(true);
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      "Error al generar la solicitud de laboratorio",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const confirmSolicitudAutorizadaLaboratorio = (data, addedPracticasAndAbonar, closeModalHandler) => async (dispatch) => {
  try {
    dispatch(startSpinner());
    const response = await LaboratorioService.confirmSolicitudAutorizadaLaboratorio( data );
    const body = await response.json();
    if (response.ok) {
      addedPracticasAndAbonar(body.turno);
      dispatch(finishSpinner());
      closeModalHandler();
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      "Error al generar el turno de laboratorio",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const uploadArchivoLaboratorioHandler = (idTipoDocumento, file) => {
  return async (dispatch) => {
    if (file.size <= TAMANO_IMAGENES.DOCUMENTACION_AFILIADOS) {
      const formData = new FormData();
      formData.append("files", file);

      dispatch(uploadArchivoLaboratorio(formData, idTipoDocumento));
    } else {
      dispatch(
        startAlerta(
          `El archivo no puede ser mayor a: ${fileSize(
            TAMANO_IMAGENES.DOCUMENTACION_AUTORIZACIONES
          )} y el mismo tiene: ${fileSize(file.size)}`,
          "info"
        )
      );
    }
  };
};

export const uploadArchivoLaboratorio = (formData, idTipoDocumento) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());
      const token =
        localStorage.getItem("token") || sessionStorage.getItem("token") || "";
      let httpHeaders;
      if (token) {
        httpHeaders = {
          Authorization: `Bearer ${token}`,
        };
      }
      const response = await fetch(
        `${baseUrl}/FileUpload/UploadFileDocumentacionLaboratorio/${idTipoDocumento}`,
        {
          method: "POST",
          body: formData,
          headers: httpHeaders,
        }
      );

      const body = await response.json();
      if (response.ok) {
        const { documentacion } = getState().laboratorio;
        const newDoc = [ ...documentacion, body ];
        
        dispatch(laboratorioSetDocumentacion(newDoc));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al guardar el documento.",
        "Ha ocurrido un error. Intente nuevamente."
      );
    }
  };
};